import React from 'react';
import moment from 'moment';

/**
 * Reusable message bubble component
 * @param {Object} message - Message object with message, op, timestamp, etc.
 * @param {boolean} isCurrentUser - Whether this message is from the current user
 * @param {string} userName - Display name for the user
 */
const MessageBubble = ({ message, isCurrentUser, userName }) => {
  const displayName = userName || message.op || message.staff_member || message.username || 'Unknown';
  const timestamp = message.timestamp || message.created_at;
  
  return (
    <div className={`flex flex-col ${isCurrentUser ? 'items-end' : 'items-start'} mb-1`}>
      <div className={`px-4 py-2 rounded-2xl max-w-[80%] break-words ${
        isCurrentUser
          ? 'bg-blue-500 text-white rounded-br-none'
          : 'bg-gray-100 rounded-bl-none'
      }`}>
        {message.message}
      </div>
      <div className="flex items-center gap-2 text-xs text-gray-500 mt-1">
        <span>{displayName}</span>
        <span>•</span>
        <span>{moment(timestamp).format('HH:mm')}</span>
      </div>
    </div>
  );
};

export default MessageBubble;

